import React from 'react';
import { Field, getFormValues } from 'redux-form';
import RenderCommonDropdownField from '../../../../../components/form-controls/RenderCommonDropdownField';
import { FLAG_URL } from '../../../../../utils/constants';
import { API_URL } from '../../../../../utils/config';
import { IStore } from '../../../../../store.type';
import { useSelector } from 'react-redux';
import { NIUM_FOREX_CROSS_SELL_FORM_NAME } from '../utils/constants';

const ForexCrossSellingAmountInput = (props: any) => {
  //@ts-ignore
  const { forex_currency } = useSelector((state: IStore) =>
    getFormValues(NIUM_FOREX_CROSS_SELL_FORM_NAME)(state)
  );

  return (
    <div className="currency-field-container">
      <div className="amount-info-container">
        <span className="forex-text">Forex Amount</span>
        <div className="currencyField">
          <Field {...props} />
        </div>
      </div>
      <div className="dropdown-container">
        <img
          src={`${FLAG_URL}${forex_currency}.png`.toLocaleLowerCase()}
          height="24"
          width="24"
          alt={forex_currency}
        />

        <div className="currency-field-dropdown-container">
          <Field
            bindToThisObject={forex_currency}
            name="forex_currency"
            component={RenderCommonDropdownField}
            className="dropdown-component"
            fluid={true}
            url={`${API_URL}/public/remitter/currencies/dropdown?country_code=IN&source_currency=INR`}
            showImage={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ForexCrossSellingAmountInput;
